import { render } from "./printManage.vue?vue&type=template&id=19a71a21&scoped=true"
import script from "./printManage.vue?vue&type=script&lang=js"
export * from "./printManage.vue?vue&type=script&lang=js"

import "./printManage.vue?vue&type=style&index=0&id=19a71a21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19a71a21"

export default script